import { render, staticRenderFns } from "./custom-color-picker.vue?vue&type=template&id=9c79950c&scoped=true&"
import script from "./custom-color-picker.vue?vue&type=script&lang=js&"
export * from "./custom-color-picker.vue?vue&type=script&lang=js&"
import style0 from "./custom-color-picker.vue?vue&type=style&index=0&id=9c79950c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c79950c",
  null
  
)

export default component.exports